import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const QuietNavbar = ({ onSignUp }) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 8);
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`quiet-navbar fixed top-0 left-0 right-0 z-40 transition-colors duration-200 ${
        scrolled ? "quiet-navbar--scrolled" : ""
      }`}
      data-testid="quiet-navbar"
    >
      <div className="cursor-nav-inner flex h-14 md:h-16 items-center justify-between px-4 md:px-6">
        <Link to="/" className="inline-flex items-center gap-2" data-testid="quiet-logo">
          <img src="/images/logo.png" alt="FractoLabs" className="h-6 w-auto md:h-7" />
        </Link>

        <div className="cursor-nav-actions">
          <Link to="/login" className="cursor-nav-login" data-testid="quiet-nav-login">
            Login
          </Link>
          <button
            type="button"
            className="cursor-nav-signup"
            onClick={onSignUp}
            data-testid="quiet-nav-signup"
          >
            Sign Up
          </button>
        </div>
      </div>
    </header>
  );
};

export default QuietNavbar;
